// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"46715d7b","72":"073f73f7","477":"39c12a2b","627":"f16b0002","663":"8d2de0a6","667":"460c4aaa","777":"f8704f11","803":"d2b4cb0e","820":"8a9ef0b2"}[chunkId] + ".chunk.js";
};